/* eslint-disable no-case-declarations */

import { COPY_CONTENT } from '../actions/copyPasteActions';

/**
 * Reducer function means a switch case to filter action data on the platform for general state
 * @param {*} state Real time updated through all components state (general state flux)
 * @param {*} action Action is an object with structyure { type: STRING, payload: FUNCTION }
 */
function copyPasteReducer(state = {}, action) {
  switch (action.type) {
    case COPY_CONTENT:
      return {
        ...state,
        ...action.payload
      };
    default:
      return state;
  }
}

export default copyPasteReducer;
